
        module.exports = __webpack_public_path__ + "assets/images/placeholder.a5ce54c8.jpg";;

        var src = '' + module.exports;

        module.exports = {

            src: src,
            width: 1280,
            height: 720,
            type: "jpg",
            bytes: 14431,

            toString: function() {
                return src;
            }
        };
    